import { FETCH_STATUS_HISTORY_DATA, FETCH_STATUS_HISTORY_DETAIL } from "../types";

const INIT_STATE = {
    statusHistoryTableData: [],
    statusHistoryTableDataRows: 0,
    statusHistoryDetailData:null
    // notificationsSettingsConfigComps: [],
    // notificationsSettingsConfigCompsRows: 0,
    // notificationSettingConfigDetailData:null,
    // allWebNotificationsList: [],
    // notificationStatusWiseCount:{}



}
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_STATUS_HISTORY_DATA: return { ...state, statusHistoryTableData: action?.payload?.data || [], statusHistoryTableDataRows: action?.payload?.count || 0 }
        case FETCH_STATUS_HISTORY_DETAIL: return { ...state, statusHistoryDetailData: action?.payload}
        default: return state

    }
}

